export var OPEN_PWA_PROMPT_EVENT_NAME = '@pwa/open-pwa-prompt';
